<template>
	<div class="appContainer">
		<div class="container" :class="{isFlash: boleto.flash == '1', isExpress: boleto.flash != '1'}">
			<div class="div_img bg-gray py-4" v-if="!show_loading && !hideHeaderAndFooter">
				<div class="text-left w-50 pl-4 py-3" v-if="(boleto_permitido.length == 1 && boleto_permitido[0] == 'PIX')">
					<img class="logo-pagbrasil mt-2" src="~@/assets/img/logos/pagbrasil.svg">
				</div>
				<div class="brand w-100 px-3 my-2" :class="{ 'justify-center': !hasLogo() }" v-else>
					<div class="d-inline-block" v-if="hasLogo()">
						<img :src="'data:image/svg+xml;base64,' + boleto.logo" v-if="boleto.logo_boleto_ext == 'SVG'">
						<img :src="'data:image/png;base64,' + boleto.logo" v-else>
					</div>
					
					<div class="d-inline-block">
						<img v-if="boleto.flash != '1'" src="~@/assets/img/logos/pagbrasil.svg" >
						<a v-if="boleto.flash == '1'" href="https://boletoflash.com/" target="_blank">
							<img src="~@/assets/img/logos/boleto_flash.svg" >
						</a>
					</div>
				</div>
			</div>

			<div class="divMobile p-0 mx-0 w-100 noprint" v-if="boleto.flash == '1' && !clicklocal">

				<div class="text-center text-lh-1 msgInstrucao my-4" v-if="!clicklocal">
					<div class="py-2 mt-2">
						<span>Selecione o banco</span><br>onde você irá pagar o boleto:
					</div>
				</div>

				<div
					v-if="boletoAtivo('PIX') && (!clicklocal || opt_pix)"
					@click="selecionaBanco('PIX')"
					class="bankOption"
				>
					<div class="bankOption__info">
						<img src="~@/assets/img/brands/icons/pix.svg">
						<span>Pague com Pix</span>
					</div>
					<div class="setaBanco"></div>
				</div>

				<div
					v-for="item in listaBanco"
					:key="item"
					class="bankOption"
					v-if="boletoAtivo(item) && (!clicklocal || (opt == item && !opt_outro))"
					@click="selecionaBanco(item)"
				>
					<div class="bankOption__info">
						<img src="~@/assets/img/brands/icons/bb.svg"		v-if="item == '001'">
						<img src="~@/assets/img/brands/icons/caixa.svg"		v-if="item == '104'">
						<img src="~@/assets/img/brands/icons/itau.svg"		v-if="item == '341'">
						<img src="~@/assets/img/brands/icons/bradesco.svg"	v-if="item == '237'">
						<img src="~@/assets/img/brands/icons/santander.svg"	v-if="item == '033'">
						<span>{{descricaoBanco(item)}}</span>
					</div>
					<div class="setaBanco"></div>
				</div>

				<div
					v-if="(!clicklocal || opt_outro) && !(boleto_permitido.length == 1 && boleto_permitido[0] == 'PIX')"
					@click="selecionaBanco('')"
					class="bankOption"
				>
					<div class="bankOption__info">
						<img src="~@/assets/img/brands/icons/others.svg">
						<span>Outros bancos</span>
					</div>
					<div class="setaBanco"></div>
				</div>
			</div>

			<div class="divMobile w-100 px-3" v-if="try_register[opt] && opt != 'PIX'">
				<div class="resumoPedido">
					<div class="order-details mr-2">
						<p class="fieldName">Nº do Pedido:</p>
						<p class="fieldName">Vencimento:</p>
						<p class="fieldName">Valor:</p>
					</div>
					
					<div class="order-details ml-2">
						<div class="text-truncate fieldValue">{{boleto.order}}</div>
						<div class="fieldValue notranslate">{{$helper.formatDate(boleto.data_vencimento)}}</div>
						<div class="fieldValue">R$ {{$helper.formatValue(boleto.valor)}}</div>
					</div>
				</div>
				
				<div class="linha_dig text-center">
					<span class="clique-codigo">Clique para copiar o código de barras:</span>
					<div ref="linhaDigitavel" class="linha_digitavel mt-1 p-2" @click="copyToClipboard(linha_digitavel)">
						<div class="linha_digitavel__code">{{ linha_digitavel }}</div>
						<inline-svg class="ml-1" :src="require('@/assets/img/pbi/pbi_copy_24.svg')" />
					</div>
					<div ref="tooltip" class="tooltip hide_tooltip noprint" role="tooltip">
						Copiado! 
						<div ref="arrow" class="arrow"></div>
					</div>
				</div>
						
				<div class="codigo_barras">
					<div id="codigo_barras_small" class="mt-3">
						<inline-svg :src="require('@/assets/img/pbi/pbi_rotacionar.svg')" />
						<div>Rotacione para ver o</br> código de barras</div>
					</div>

					<div id="codigo_barras_full">
						<img :src="barcode_aux" v-if="refresh">
					</div>
				</div>
			</div>

			<div class="divMobile w-100 px-3" v-if="opt == 'PIX'">
				<PaymentMethodPixMobile />
			</div>

			<div class="bx-b-completo px-3 noprint" v-if="try_register[opt] && opt != 'PIX'">
				<button class="boleto_completo" @click="exibeCompleto">
					<span>Ver o boleto completo</span>
				</button>
			</div>

			<div class="rodape text-center" v-if="!show_loading && !hideHeaderAndFooter">
				<div class="hr"></div>
				<a href="https://pagbrasil.com" target="_blank" class="no_decoration">
					{{ onlyPix ? 'Pagamento' : 'Boleto' }} processado pela <b>PagBrasil</b>
				</a>
			</div>
		</div>

		<Loader />
	</div>
</template>

<script>
import PaymentMethodPixMobile from '@/components/PaymentMethodPixMobile.vue'
import Loader from '@/components/Loader.vue'

import InlineSvg from 'vue-inline-svg'
import {
	computePosition,
	flip,
	offset,
	arrow
} from "@floating-ui/dom"
import { mapActions } from 'vuex'

export default {
	name: 'BoletoMobileB',

	components: {
		PaymentMethodPixMobile,
		Loader,
		InlineSvg
	},

	data(){
		return {
			refresh: false,
			onlyPix: false
		}
	},


	mounted: function(){

		let self = this;

		this.$nextTick(() => {
			self.refreshImg();

			// Se tem apenas o PIX habilitado, já "clica" no pix
			if(self.boleto_permitido.length == 1 && self.boleto_permitido[0] == 'PIX'){
				self.onlyPix = true;
				self.selecionaBanco("PIX");
			}
		});
	},

	computed: {

		show_loading(){
			return this.$store.state.boleto.show_loading;
		},

		boleto(){
			return this.$store.state.boleto.boleto;
		},

		opt(){
			return this.$store.state.boleto.opt;
		},

		boletoA(){
			return this.$store.state.boleto.boletoA;
		},

		boletoB(){
			return this.$store.state.boleto.boletoB;
		},

		opt_outro(){
			return this.$store.state.boleto.opt_outro;
		},

		opt_pix(){
			return this.$store.state.boleto.opt_pix;
		},

		ag_beneficiario(){
			return this.$store.state.boleto.ag_beneficiario;
		},

		boletobanco(){
			return this.$store.state.boleto.boletobanco;
		},

		try_register(){
			return this.$store.state.boleto.try_register;
		},

		opcao_clicada(){
			return this.$store.state.boleto.opcao_clicada;
		},

		boletonotfound(){
			return this.$store.state.boleto.boletonotfound;
		},
		
		forceMobile(){
			return this.$store.state.boleto.forceMobile;
		},

		hideHeaderAndFooter(){
			return this.$store.state.boleto.hideHeaderAndFooter;
		},

		barcode_aux(){

			var baseUrl = process.env.VUE_APP_BASEURL + ':' + process.env.VUE_APP_BASEURLPORT + "/api/boleto/";
			if(process.env.NODE_ENV != 'development'){
				baseUrl = process.env.VUE_APP_BASEURL;
			}

			let aux = baseUrl + 'getBarcode.php?';
			aux += 'valor=';

			let valor = '00000000000000000000000000000000000000000000';
			if(typeof this.boletobanco.barcode != "undefined"){
				valor = this.boletobanco.barcode;
			}

			let cont = 0;
			for(let i=0; i< valor.length; i++){
				cont += parseInt(valor[i]);
			}

			aux += valor + "_" + cont;

			return aux;
		},

		linha_digitavel(){
			return this.$options.filters.linha_quebra(this.boletobanco.linha_digitavel);
		},

		boleto_permitido(){
			return this.$store.state.boleto.boleto_permitido;
		},

		listaBanco(){
			return this.$store.state.boleto.listaBanco;
		},

		clicklocal(){
			return this.$store.state.boleto.clicklocal;
		},
	},

	methods:{
		...mapActions({
			tryRegistro: 'boleto/tryRegistro'
		}),

		selecionaBanco(banco){
			this.tryRegistro(banco).then(() => {
				this.$store.commit("boleto/setClicklocal", true);
				this.$store.commit("boleto/setOpcaoClicada", true);
				this.refreshImg();
			});

			this.$store.commit('boleto/sendPostIframeOptionSelected');
		},

		refreshImg(){
			let self = this;
			self.refresh = false;
			window.setTimeout(
				function(){
					self.refresh = true;
				},
				50);
		},

		copyToClipboard(value){
			this.$helper.copyToClipboard(value);

			const tooltip = this.$refs.tooltip;
			tooltip.classList.remove('hide_tooltip');
			tooltip.classList.add('show_tooltip');

			this.renderTooltip();

			setTimeout(() => {
				tooltip.classList.remove('show_tooltip');
				tooltip.classList.add('hide_tooltip');
			}, 2000);
		},

		renderTooltip(){
			const linhaDigitavel	= this.$refs.linhaDigitavel;
			const tooltip			= this.$refs.tooltip;
			const arrowEl			= this.$refs.arrow;
		
			computePosition(linhaDigitavel, tooltip, {
				placement: 'bottom',
				middleware: [offset(6), flip(), arrow({ element: arrowEl })],
			}).then(({x, y, placement, middlewareData}) => {
				Object.assign(tooltip.style, {
					left: `${x}px`,
					top: `${y}px`,
				});

				const {x: arrowX, y: arrowY} = middlewareData.arrow;

				const staticSide = {
					top: 'bottom',
					right: 'left',
					bottom: 'top',
					left: 'right',
				}[placement.split('-')[0]];

				Object.assign(arrowEl.style, {
					left: arrowX != null ? `${arrowX}px` : '',
					top: arrowY != null ? `${arrowY}px` : '',
					right: '',
					bottom: '',
					[staticSide]: '-8px',
				});
			});
		},

		exibeCompleto(){
			window.open(window.location.href + "&desktop=1&brand="+ this.opt);
		},

		boletoAtivo(val){
			if(this.boleto_permitido.indexOf(val) != -1){
				return true;
			}
			return false;
		},
		
		hasLogo(){
			if(this.boleto.logo != null && this.boleto.logo != ''){
				return true;
			}
			return false;
		},

		descricaoBanco(banco){
			return this.$store.getters["boleto/descricaoBanco"](banco);
		},
	},

	filters:{
		linha_quebra(val){
			if(typeof val == "undefined" || val == ''){
				return '';
			}
			let ret = val.substr(0,5);
			ret += ""; // ponto
			ret += val.substr(5,5);
			ret += " ";
			ret += val.substr(10,5);
			ret += ""; // ponto
			ret += val.substr(15,6);
			ret += " ";
			ret += val.substr(21,5);
			ret += ""; // ponto
			ret += val.substr(26,6);
			ret += " ";
			ret += val.substr(32,1);
			ret += " ";
			ret += val.substr(33);

			return ret;
		}
	}
}

</script>
